export default __webpack_public_path__ + "static/media/deleteAccountStep3.8323e1f2.png";